import React from "react";
import "./About.css";

import { Navbar } from "./Navbarm";

export const About = () => {
  return (
    <div>
      <Navbar />


<h1 className="todayhead">Stay Inspired</h1>
  <div className="today"> 
  <div>
  <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSpfpng1-apvrXOs2oGJLd63ngRL4mCZWYn_g&usqp=CAU" alt="" />
   <h1 className="todaytext">In the Spotlight</h1>
   <h1 className="todaytextHead">Indian Bridal Designers</h1>
  </div>
  <div>
  <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ_frVbDs4ZcU1GbITPIwGcNA5dTgqAJxXi8Q&usqp=CAU" alt="" />
  <h1 className="todaytext">Street Style Snapshot</h1>
   <h1  className="todaytextHead2">Fashion Week Inspo</h1>
  </div>

  <div>
  <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRoR_MpRL_ZLC3AqKPkIaGdEJDt1UP8E00sSA&usqp=CAU" alt="" />
  <h1 className="todaytext">Bollywood Friday</h1>
   <h1  className="todaytextHead1">Couple Goals</h1>
  </div>
  <div>
  <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ_OD6ftGaSR_L4w2AwWWEbUPs9UbeJNObFfg&usqp=CAU" alt="" />
  <h1 className="todaytext">Beautiful Women</h1>
   <h1  className="todaytextHead3">Rajasthani Folk Art</h1>
  </div>

   </div>

   
  <h1 className="secondtodeay">February 23, 2022</h1>
  <div className="today"> 
  <div>
  <img src="https://i.pinimg.com/236x/a2/b4/b5/a2b4b5bf3e0bd996d471137dfe35c309.jpg" alt="" />
   <h1 className="todaytext">Balle Balle</h1>
   <h1 className="todaytextHead">Travel Through Food Punjab</h1>
  </div>
  <div>
  <img src="https://i.pinimg.com/736x/65/b5/bf/65b5bfbfa4a70575ea6d368fc40157ce.jpg" alt="" />
  <h1 className="todaytext">Shaadi Guide</h1>
   <h1  className="todaytextHead2">Wedding Mandap Ideas</h1>
  </div>

  <div>
  <img src="https://i.pinimg.com/736x/56/5e/3b/565e3baa3afeebe76194a4b1cf974332.jpg" alt="" />
  <h1 className="todaytext">Grow a green thumb</h1>
   <h1  className="todaytextHead1">Gardeening Tips for Beginners</h1>
  </div>
  <div>
  <img src="https://i.pinimg.com/236x/e0/78/54/e0785482a9958ad5bae449f4d81dc807.jpg" alt="" />
  <h1 className="todaytext">Find Your Realaxation Mode</h1>
   <h1  className="todaytextHead3">Self Care Aesthetic</h1>
  </div>

   </div>
   <div className="footera">
   <h1 className="todayfooter1">That's all for today!</h1>
   <h1  className="todayfooter">Come back tomorrow for</h1>
   <h1  className="todayfooter2">more inspiration</h1>

   </div>


   <button className="gotohomepage">Go to HomePage</button>

    </div>
  );
};
